import { createSelector } from '@reduxjs/toolkit';
import { selectSelectedDevice } from 'entities/device/lib';
import { partial } from 'webui/utils/functions';
export function showGuideInMainTab(ui_guide_statuses, appliance_type, group) {
    // Просили на главной странице показывать?
    if (!group.show_on_main_tab) {
        return false;
    }
    const is_type_correct = is_appliance_type_correct(group, appliance_type);
    const current_group_status = ui_guide_statuses.find(({ group_id }) => group_id === group.id);
    // т.е. мы никогда не видели это обучение
    if (!current_group_status) {
        return is_type_correct;
    }
    if (current_group_status.rejected) {
        return false;
    }
    if (current_group_status.skipped) {
        return false;
    }
    return !current_group_status.passed && is_type_correct;
}
function is_appliance_type_correct(group, dev_appliance_type) {
    if (group.appliance_types == null) {
        return true;
    }
    if (dev_appliance_type == null) {
        return true;
    }
    return group.appliance_types.includes(dev_appliance_type);
}
export const needShowSomeGuide = createSelector((state) => state.account.is_demo, (state) => {
    const available_guides = state.ui_guide_state.available_ui_guide_groups;
    const guide_statuses = state.account.ui_guide_statuses ?? [];
    const appliance_device_type = selectSelectedDevice(state)?.appliance_type ?? null;
    const f1 = partial(showGuideInMainTab, guide_statuses);
    return available_guides.some(partial(f1, appliance_device_type));
}, (is_demo, show) => !is_demo && show);
export const uiGuideForShow = createSelector((state) => state.ui_guide_state.available_ui_guide_groups, (state) => state.account.ui_guide_statuses ?? [], (state) => selectSelectedDevice(state), (available_guides, guide_statuses, selected_device) => {
    const appliance_device_type = selected_device?.appliance_type ?? null;
    const f1 = partial(showGuideInMainTab, guide_statuses);
    const f2 = partial(f1, appliance_device_type);
    return available_guides.find(f2);
});
export function select_ui_guide_by_id(state, id) {
    for (const guide of state.ui_guide_state.available_ui_guide_groups ?? []) {
        if (guide.id === id) {
            return guide;
        }
    }
    return null;
}
export function is_current_device_has_valid_appliance(state, appliance_types) {
    const dev = selectSelectedDevice(state);
    return dev === undefined ? false : appliance_types.includes(dev.appliance_type);
}
